module.exports = __webpack_public_path__ + "static/party_bn1@2x-17e6e40e1f3762990e1d6a0086267541.jpg";